export default __webpack_public_path__ + "static/media/CloseGraphSideBar.81cf3561.svg";